"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Toggle = _interopRequireDefault(require("../../../helpers/Toggle"));
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _Button = _interopRequireDefault(require("../../../Button/Button"));
var _constants = require("../../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Split = function Split(_ref) {
  var _ref$data = _ref.data,
    flip = _ref$data.flip,
    title = _ref$data.title,
    content = _ref$data.content,
    image = _ref$data.image,
    textDecoration = _ref$data.text_decoration,
    videoEmbedLink = _ref$data.video_embed_link,
    videoTitle = _ref$data.video_title,
    videoButtonText = _ref$data.video_button_text,
    inView = _ref.inView;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-decoration-row flex items-center@sm flex-gap-xl margin-top-md flex-column flex-row@sm"
  }, flip && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, title), /*#__PURE__*/_react["default"].createElement("p", null, content), videoEmbedLink && /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var toggle = _ref2.toggle,
      on = _ref2.on;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.ERROR,
      icon: "play",
      text: videoButtonText,
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      toggle: toggle,
      on: on,
      title: videoTitle,
      video: videoEmbedLink
    }));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: inView ? image.url : '',
    className: "max-width d8-u-radius-md",
    alt: image.name
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "absolute text-decoration flip"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, textDecoration))))), !flip && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative tac"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: inView ? image.url : '',
    className: "max-width d8-u-radius-md",
    alt: image.name
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "absolute text-decoration"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, textDecoration)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, title), /*#__PURE__*/_react["default"].createElement("p", null, content), videoEmbedLink && /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref3) {
    var toggle = _ref3.toggle,
      on = _ref3.on;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.ERROR,
      icon: "play",
      text: videoButtonText,
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      template: "Video",
      toggle: toggle,
      on: on,
      title: videoTitle,
      video: videoEmbedLink
    }));
  })))));
};
Split.propTypes = {
  data: _propTypes["default"].object,
  inView: _propTypes["default"].bool
};
var _default = exports["default"] = Split;